// removed by extract-text-webpack-plugin
module.exports = {"coverImage":"_3o0sAZFUyJoqKGmuvRt323","content":"_3Xm4PzRIFfqeozanTP-4D3","image":"_3C28rknyKZiWdpmk1e3HeT","shadow300":"_170q1M8yo9NML_l6t98YTz","shadow500":"_1IXE-K4og9EEAoTMvFz4Vc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/ImageContent/style.css
// module id = 266
// module chunks = 42